import React from 'react';
import { ORDER_STATUS, ORDER_STATUS_LABELS } from '../../../constants';

const OrderDetailsHeader = ({
  customerName,
  customerInfo,
  orderStatus,
  onOrderStatusChange,
  isLoading,
  isMontajci,
  permissions,
  isAddingOrder,
  onToggleAddOrder
}) => {
  return (
    <div className="order-header">
      <div className="order-header-left">
        <h4>Sipariş Detayları</h4>
        {customerName && (
          <div className="customer-info">
            <div className="customer-name">
              <strong>Müşteri:</strong> {customerName} {customerInfo?.tcNo && (
                <span style={{ marginLeft: '10px', fontSize: '12px', color: '#64748b' }}>
                  (TC/Vergi No: {customerInfo.tcNo})
                </span>
              )}
            </div>
            <div className="order-status-selector">
              <label>Sipariş Durumu:</label>
              <select
                value={orderStatus || ORDER_STATUS.NEW_ORDER}
                onChange={(e) => {
                  if (onOrderStatusChange) {
                    // Montajcı sadece Teslim Edildi yapabilir
                    if (isMontajci && e.target.value !== ORDER_STATUS.DELIVERED) {
                      return;
                    }
                    onOrderStatusChange(e.target.value);
                  }
                }}
                disabled={isLoading || (isMontajci && orderStatus === ORDER_STATUS.DELIVERED)}
              >
                {isMontajci ? (
                  <>
                    <option value={orderStatus}>{ORDER_STATUS_LABELS[orderStatus]}</option>
                    {orderStatus !== ORDER_STATUS.DELIVERED && (
                      <option value={ORDER_STATUS.DELIVERED}>{ORDER_STATUS_LABELS[ORDER_STATUS.DELIVERED]}</option>
                    )}
                  </>
                ) : (
                  Object.entries(ORDER_STATUS_LABELS).map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))
                )}
              </select>
            </div>
          </div>
        )}
      </div>
      <div className="order-header-right">
        {permissions?.canCreateOrder && (
          <button
            onClick={onToggleAddOrder}
            className="add-order-btn"
            disabled={isLoading}
          >
            {isAddingOrder ? 'İptal' : '+ Sipariş Ekle'}
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderDetailsHeader;
